import { Injectable } from '@angular/core';
import { ConfigurationModule } from '../../configuration.module';
import { ResetPasswordConfiguration } from './reset-password-configuration';

@Injectable({
  providedIn: ConfigurationModule
})
export class ResetPasswordConfigurationService {

 configuration: ResetPasswordConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = configuration;
  }
}
